module.exports = __webpack_public_path__ + "img/window2.01941f2a.png";